import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const names = ['Martín', 'Juan', 'Lucas', 'Diego', 'Federico', 'Pablo', 'Alejandro', 'Matías', 'Nicolás', 'Tomás', 'Facundo', 'Gonzalo', 'Carolina', 'Sofía', 'Lucía', 'Valentina'];
const cities = ['Rosario', 'Córdoba', 'Mendoza', 'Buenos Aires', 'La Plata', 'Mar del Plata', 'Salta', 'Tucumán', 'Santa Fe', 'Neuquén', 'Corrientes', 'San Juan'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyer, setBuyer] = useState({
    name: '',
    city: ''
  });
  const hideRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    const trigger = () => {
      setBuyer({
        name: names[Math.floor(Math.random() * names.length)],
        city: cities[Math.floor(Math.random() * cities.length)]
      });
      setIsVisible(true);
      hideRef.current = setTimeout(() => setIsVisible(false), 5000);
    };
    // First popup shortly after load, then repeat every 30 seconds.
    const initial = setTimeout(trigger, 8000);
    const loop = setInterval(trigger, 30000);
    return () => {
      clearTimeout(initial);
      clearInterval(loop);
      if (hideRef.current) clearTimeout(hideRef.current);
    };
  }, []);
  return <AnimatePresence data-id="element-289">
      {isVisible && <motion.div initial={{
      x: -120,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -120,
      opacity: 0
    }} className="fixed bottom-24 sm:bottom-6 left-4 sm:left-6 z-40" data-id="element-290">
          <button onClick={() => setIsVisible(false)} className="bg-white border border-gray-200 shadow-xl rounded-xl p-4 flex items-start gap-3 max-w-[300px] text-left" data-id="element-291">
            <CheckCircle className="w-5 h-5 text-f360-green flex-shrink-0 mt-0.5" data-id="element-292" />
            <div data-id="element-293">
              <p className="text-sm text-gray-800 leading-snug" data-id="element-294">
                🎉 <span className="font-bold" data-id="element-295">{buyer.name}</span> de{' '}
                <span className="font-bold" data-id="element-296">{buyer.city}</span> acaba de comprar
                FÚTBOL 360
              </p>
              <p className="text-xs text-gray-500 mt-1" data-id="element-297">hace unos minutos</p>
            </div>
          </button>
        </motion.div>}
    </AnimatePresence>;
}